<mat-toolbar class="primary">
  @for (i of items(); track i) {
    <button
      ngx-bottom-nav
      [hideLabel]="hideLabels"
      [routerLink]="i.routerLink"
      [label]="i.label"
      [exact]="i.exact"
      [icon]="i.icon">
      <mat-icon ngxBottomNavIcon>{{ i.icon }}</mat-icon>
    </button>
  }
  <ng-content select="[ngx-bottom-nav]"></ng-content>
</mat-toolbar>
